import { isPresent } from 'utils/isPresent';
import React, { memo } from 'react'
import { compose } from 'redux'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import Face from 'housecall-ui/dist/IconsAndImages/Icons/Face'
import SelectedCustomer from './SelectedCustomer.jsx'
import TasksApi from '../Api/TasksApi'
import SearchCustomer from '../../../Customers/AddOrEditCustomer/SearchCustomers.jsx'

const styles = theme => ({
  searchField: {
    width: '100%',
    color: theme.palette.secondary.light,
    textTransform: 'none',
  },
  textFieldContainer: {
    width: '90%',
  },
  textFieldInput: {
    fontSize: '14 !important',
    fontWeight: '500 !important',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  },
  faceIcon: {
    color: theme.palette.secondary.light,
  },
  iconWrapper: {
    padding: 8,
  },
  inputWrapper: {
    padding: 8,
  },
})

const CustomerSelection = ({ classes, customer, onCustomerChange }) => {
  const handleSearchCustomer = (customer, clearSearch) => {
    onCustomerChange(customer)
    clearSearch()
  }

  const renderCreateUpdateCustomer = () => {
    if (isPresent(customer)) {
      return (
        <SelectedCustomer
          customer={customer}
          onCustomerChange={onCustomerChange}
        />
      )
    }

    return (
      <SearchCustomer
        className={classes.searchField}
        onSelect={(customer, clearSearch) =>
          handleSearchCustomer(customer, clearSearch)
        }
        onSearch={TasksApi.searchCustomer}
        InputProps={{
          disableUnderline: true,
          classes: {
            input: classes.textFieldInput,
          },
        }}
        shouldAddEmptyCustomer={false}
        hintText="Add customer"
        showNotes={false}
      />
    )
  }

  return (
    <Grid
      container
      item
      className={classes.textFieldContainer}
      alignItems="center"
      justify="flex-start"
      wrap="nowrap"
      xs={12}
    >
      <div className={classes.iconWrapper}>
        <Face className={classes.faceIcon} />
      </div>
      <div className={classes.inputWrapper}>{renderCreateUpdateCustomer()}</div>
    </Grid>
  )
}

export default compose(withStyles(styles), memo)(CustomerSelection)
